import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION_Mapper extends BaseFormMapper<CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION);

		return _formData;
	}

	MapValues(): Partial<CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION> {
		return {};
	}
}

const Mappings: CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION =
	{
		// "0":"ButtonSubmit0",
		electronicRegistration: 'CC001',
		// "2":"t114",
		date: 't9999',
		faxNumber: 't9609',
		telephoneNumber: 't9607',
		lawFirmName: 't9604',
		mortgageAmount: 't860',
		registryOffice: 't330',
		mortgageDate: 'tSF#1124',
		registrationDate: 't@PG#/305',
		parcelIdentificationNumber: 't4100',
		registrationNumber: 't1015',
		legalDescription: 'Text2',
		propertyAddress: 't300',
		mortgagors: 't3389',
		cibcClassReferenceNumber: 't3175',
		branchNumber: 'Text1',
	};
export interface CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION {
	branchNumber: string;
	cibcClassReferenceNumber: string;
	mortgagors: string;
	propertyAddress: string;
	legalDescription: string;

	electronicRegistration: string;
	registrationNumber: string;
	mortgageDate: string;
	parcelIdentificationNumber: string;

	registryOffice: string;
	registrationDate: string;

	mortgageAmount: string;

	lawFirmName: string;
	telephoneNumber: string;
	faxNumber: string;
	date: string;
}
